// extracted by mini-css-extract-plugin
export default {"DynamicSeparator":"contextMenu_DynamicSeparator__dunCn","ItemContent":"contextMenu_ItemContent__EzUG7","ItemIcon":"contextMenu_ItemIcon__-nkYf"};